import React from 'react';
import Icon from '../../../components/AppIcon';

const StatCard = ({ title, value, change, changeType, icon, iconBg }) => {
  return (
    <div className="bg-card rounded-2xl p-4 md:p-6 elevation-sm">
      <div className="flex items-start justify-between mb-3">
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center ${iconBg}`}>
          <Icon name={icon} size={20} color="#FFFFFF" />
        </div>
        {change && (
          <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
            changeType === 'positive' ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
          }`}>
            <Icon name={changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} size={14} />
            <span>{change}</span>
          </div>
        )}
      </div>
      <h3 className="text-2xl md:text-3xl font-semibold text-foreground mb-1">{value}</h3>
      <p className="text-sm text-muted-foreground">{title}</p>
    </div>
  );
};

export default StatCard;